export default __webpack_public_path__ + "media/google-play-qr.ae753.png";